module.exports = __webpack_public_path__ + "static/media/P13.c0e16d0f.jpg";